import React from 'react';

import { SEO } from 'main/components';
import { BoxesContent, Chapters, Hero, StartJourney } from 'modules/fpvAce';

export const FPVAce = () => {
  return (
    <>
      <SEO seoTitle="FPV.Ace - Learn to Fly Drones with Drone Kit - Orqa" />
      <section className="fpv-ace-section">
        <Hero />
        <BoxesContent />
        <Chapters />
        <StartJourney />
      </section>
    </>
  );
};
